import { useContext, useEffect, useState } from "react";
import KrFormContext, { KrFormContextLandslideType, KrLandslideFormTypes, NavHeadingsKROEnum } from "../../../../contexts/krFormContext";
import { RastersAttributes } from "../../../../contexts/poFormContext";
import { ConfirmModalProps } from "../../../../components/modalWindow/types/confirmModalProps";
import ConfirmModal from "../../../../components/modalWindow/confirmModal";
import { TextAreaFieldProps } from "../../../../components/textAreaField/types/textAreaFieldProps";
import TextAreaField from "../../../../components/textAreaField/textAreaField";
import { RasterType } from "../types/krFormView";
import { UploadProps } from "./shared/types/uploadProps";
import UploadRasters from "./shared/uploadRasters/uploadRasters";
import { createConfigValidation, validation } from "../../../../helpers/validation/validation";
import { getFieldRef, getItemRef, renderSectionCommentBtn } from "../../../../helpers/form";
import { KROFieldDict } from "../../shared/commentsSidebar/fieldDict";
import { PatternType } from "../../../../contexts/types/card";

const PhotographicDocumentation = (props: any) => {
    const { krForm, setkrForm } = useContext(KrFormContext) as KrFormContextLandslideType;
    const [fileRow, setFileRow] = useState<RastersAttributes>();
    const [confirmation, setConfirmation] = useState<boolean>(false);
    const [infoText, setInfoText] = useState("");
    const [isInactive, setIsInactive] = useState(false);
    const [tableError, setTableError] = useState<boolean>(false);
    const [tableErrorMsg, setTableErrorMsg] = useState<string>("");
    const [focusTable, setFocusTable] = useState<boolean>(false);

    const refocus = () => {
        setFocusTable(true);
    }

    const maxFileSize: any = 1048576;  // ~ 1 MB
    const maxFileDimensions: any = 2000;
    const maxFileNumberForUpload: any = 30;
    const rasterType: RasterType = RasterType.Image;

    const activityCheck = () => {
        if (krForm.activityZones && krForm.activityZones.length > 0 && krForm.activityZones.some((item) => item.tyP_AKTYWNOSCI_DOM === "nieaktywne")) {

            var activityArea: number = 0;
            var area = krForm.activityZones.find((item) => { return item.tyP_AKTYWNOSCI_DOM === "nieaktywne" })?.powierzchnia;

            for (var i = 0; i < krForm.activityZones.length; i++) {
                activityArea += +krForm.activityZones[i].powierzchnia!;
            }

            var percent = area! / activityArea * 100;
            if (percent === 100) setIsInactive(true);
        }
    }

    useEffect(() => {
        var landslideImages = krForm.landslideRasters?.filter((item) => {
            return item.details?.rodzaj === rasterType;
        })

        activityCheck();

        if (landslideImages?.length === 0) {
            setInfoText(isInactive ?
                "Brak możliwości przedstawienia na fotografii całego obszaru osuwiska" :
                "Brak możliwości przedstawienia na fotografii całego obszaru osuwiska lub aktywnych fragmentów i zniszczeń wywołanych przez osuwisko.")
        }
        else {
            if (infoText !== null) setInfoText("");
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps 
    }, [krForm.landslideRasters, krForm.activityZones]);

    const refreshValidation = (values: any, name: string) => {
        const currValidation = createConfigValidation(name, false);
        const currValidationMsg = validation(currValidation, values, props.additionalDesc, true);
        if (currValidationMsg) {
            setTableError(true);
            setTableErrorMsg(currValidationMsg);
        } else {
            setTableError(false);
            setTableErrorMsg('');
        }
    }

    // Validation
    useEffect(() => {
        if (krForm.config?.check && !krForm.config.isValid) {
            const currValidation = createConfigValidation("rastersElements", false);
            var data = (krForm as KrLandslideFormTypes).landslideRasters?.filter((raster: any) => {
                return (raster.details.rodzaj === rasterType)
            })
            const errorMsg = validation(currValidation, data, props.additionalDesc, true);
            if (errorMsg !== '') {
                setTableError(true);
                setTableErrorMsg(errorMsg);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [krForm.config?.check])

    // Section info textarea
    var sectionInfoTextarea: TextAreaFieldProps = {
        value: infoText,
        textareaSharedProps: {
            className: 'largeFormTextarea body-txt-large',
            style: {
                height: '75px'
            }
        },
        disabled: true,
        pristine: true
    }

    // Rasters upload
    var uploadRastersProps: UploadProps = {
        maxFileSize: maxFileSize,
        maxFileDimensions: maxFileDimensions,
        maxFileNumberForUpload: maxFileNumberForUpload,
        rasterType: rasterType,
        acceptedFiles: [
            "image/jpg",
            "image/jpeg"
        ],
        acceptedFilesForSnackbar: ".jpg lub .jpeg",
        dropzoneText: <>
            Przeciągnij i upuść plik w formacie .jpg/.jpeg, aby dodać go do formularza.
            <br></br>Pliki powyżej 1MB lub długość boku 2000 pix będą skalowane do odpowiedniego rozmiaru.
            <br></br>Jednocześnie wgrać można maksymalnie 30 plików.
        </>,
        isLandslide: props.isLandslide,
        infoSectionChangeHandler: () => { if (infoText !== null) setInfoText(""); },
        clickRowHandler: setFileRow,
        confirmationToggle: setConfirmation,
        foldoutInputValidation: {
            minCharacters: {
                minNumberOfCharacters: 10,
                errorMsg: "Należy wpisać minimum 10 znaków"
            }
        },
        tableError: tableError,
        tableErrorMsg: tableErrorMsg,
        refreshValidation: refreshValidation,
        getMapForComment: props.getMapForComment,
        editMode: props.editMode,
        setNewCommentFieldDetails: props.setNewCommentFieldDetails,
        KRFieldDictForRows: KROFieldDict.dokFoto_dokumentacjaFotograficzna,
        fieldFormNameForRows: props.version === 1 ? "Fotografia (-ie) osuwiska" : "Dokumentacja fotograficzna",
        setCommentsFilter: props.setCommentsFilter,
        markedFieldForCommentFiltering: props.markedFieldForCommentFiltering,
        refocus: focusTable,
        setRefocusTable: setFocusTable
    }

    // Confirm delete image
    const confirm = () => {
        setConfirmation(false);
        deleteFile(fileRow);
    }

    const deleteFile = (row: any) => {
        var form: any = Object.assign({}, krForm);
        if (form !== null && form.landslideRasters) {
            form.landslideRasters = form.landslideRasters.filter((item: any) => {
                return item.details.globalid !== row.globalid;
            });
        }
        var data = (form as KrLandslideFormTypes).landslideRasters?.filter((raster: any) => {
            return (raster.details.rodzaj === rasterType)
        })
        refreshValidation(data, "rastersElements");
        setkrForm(form);
    }

    const cancel = () => {
        setConfirmation(false);
    }

    const getQuestion = () => {
        return `Czy na pewno chcesz usunąć plik ${fileRow?.pliK_NAZWA}?`;
    }

    var confirmDeleteImage: ConfirmModalProps = {
        width: "660px",
        height: "auto",
        confirmTitle: "Tak, usuń plik",
        onConfirm: confirm,
        cancelTitle: "Anuluj",
        onCancel: cancel,
        question: getQuestion(),
        refocus: refocus
    }

    const getSectionHeading = () => {
        return props.version === PatternType.P2007 ? "16. Fotografia (-ie) osuwiska" : "16. Dokumentacja fotograficzna";
    }

    return (
        <>
            <div ref={(node: any) => {getFieldRef(node, KROFieldDict.dokFoto_sekcja, props.getMapForComment!)}} style={{ width: "100%" }}>
                <h2 ref={(node) => getItemRef(node, NavHeadingsKROEnum.PhotographicDocumentation, props.getMapForNavScroll!)}
                    onClick={() => { if(props.setCommentsFilter) props.setCommentsFilter(KROFieldDict.dokFoto_sekcja); }}
                >
                    {getSectionHeading()}
                </h2>
                {!props.editMode && renderSectionCommentBtn(props.markedFieldForCommentFiltering === KROFieldDict.dokFoto_sekcja, false, getSectionHeading(), props.setNewCommentFieldDetails!, KROFieldDict.dokFoto_sekcja)}
                <TextAreaField {...sectionInfoTextarea} /> <br />
                <UploadRasters {...uploadRastersProps} />
            </div>
            {confirmation && <ConfirmModal {...confirmDeleteImage} />}
        </>
    )
}

export default PhotographicDocumentation;